// extracted by mini-css-extract-plugin
export default {"container":"styles_container__b9Oq3","label":"styles_label__HRwDL"};